import { ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, OnInit, Renderer2 } from '@angular/core';
import { ControlContainer, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseFpxControlComponent } from '@fpx/core';

@Component({
  selector: 'fpx-hidden',
  templateUrl: './fpx-hidden.component.html',
  styleUrls: ['./fpx-hidden.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FpxHiddenComponent),
      multi: true
    }
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FpxHiddenComponent extends BaseFpxControlComponent {

  constructor(controlContainer: ControlContainer, changeDetectorRef: ChangeDetectorRef, private _renderer: Renderer2) {
    super(controlContainer, changeDetectorRef);
  }

}
